import React from 'react'

const ExtraComp = () => {
  return (
    <>
      <div className="relative text-center pb-16 px-10 bg-transparent backdrop-blur-xl">
        <p className=" text-3xl font-medium text-[#192027]">
          EasyOFFICE's - TDS module file all your TDS return requirements & <br />simplify the
          process of TDS Calculation
        </p>
        <p className=" text-3xl font-medium text-[#192027] mt-3">
          Join with Thousands of Happy CA’s & Tax Professionals <br />Who believes in
          EasyOFFICE Software
        </p>
        <div className=" mt-10">
          <a
            href="https://www.easyofficesoftware.com/public/demo/demo/EasyOfficeDemoSetup.exe"
            target="_blank"
            rel="noreferrer"
            className="sm:px-20 px-6 py-2 sm:py-4 bg-gradient-to-r from-[#686bff] to-[#00b812] text-white rounded-lg text-2xl font-bold duration-200 transform hover:rounded-full hover:-translate-y-1 transition"
          >
            Download Demo
          </a>
        </div>
      </div>
    </>
  );
}

export default ExtraComp;